import { render, staticRenderFns } from "./VisualizarNotificacao.vue?vue&type=template&id=64523ccd&scoped=true"
import script from "./VisualizarNotificacao.vue?vue&type=script&lang=ts"
export * from "./VisualizarNotificacao.vue?vue&type=script&lang=ts"
import style0 from "./VisualizarNotificacao.vue?vue&type=style&index=0&id=64523ccd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64523ccd",
  null
  
)

export default component.exports